import { render, staticRenderFns } from "./audiences.vue?vue&type=template&id=67d0b4eb&"
import script from "./audiences.vue?vue&type=script&lang=js&"
export * from "./audiences.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports